/**
 * murals-tracking.js
 *
 * Lead-generation GA4 tracking for the Murals theme.
 *
 * GA4 (G-HQL3HCJTC3) runs inside Shopify's SANDBOXED Web Pixel, so window.gtag
 * and window.dataLayer do NOT exist in the theme's page context. We therefore
 * emit custom events into the Customer Events sandbox via
 *   Shopify.analytics.publish(name, params)
 * and a Custom Pixel (Admin → Settings → Customer events) subscribes and
 * forwards them to GA4. Setup + pixel code: GA4-lead-tracking-setup.md.
 *
 * Events emitted:
 *   select_pattern, select_support        (configurator swatches)
 *   add_to_request, remove_from_request   (request list — murals-request-list.js)
 *   view_request_list                     (drawer open — murals-request-info-drawer)
 *   generate_lead, lead_submit_error      (drawer submit — murals-request-info-drawer)
 *   download_regolamento                  (Pattern Lab contest)
 *
 * Public API (window.MuralsTracking):
 *   track(name, params)  — publish an event to the Customer Events sandbox
 *   viewCart()           — legacy no-op-ish (kept for cart-drawer.js compat)
 */
(function () {
  'use strict';

  var queue = [];

  function canPublish() {
    return !!(window.Shopify && window.Shopify.analytics &&
              typeof window.Shopify.analytics.publish === 'function');
  }

  function doPublish(name, params) {
    try {
      window.Shopify.analytics.publish(name, params);
      return true;
    } catch (e) {
      if (window.console) console.warn('[murals-tracking] publish failed', name, e);
      return false;
    }
  }

  function flush() {
    if (!canPublish() || !queue.length) return;
    var pending = queue.splice(0, queue.length);
    for (var i = 0; i < pending.length; i++) doPublish(pending[i][0], pending[i][1]);
  }

  function track(eventName, params) {
    params = params || {};
    if (canPublish()) { doPublish(eventName, params); return; }
    // Sandbox not ready yet — queue and retry shortly.
    queue.push([eventName, params]);
  }

  // The Shopify analytics library can load slightly after the theme JS. Retry
  // flushing the queue for a while, then give up.
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    flush();
    if (tries > 40 || (canPublish() && !queue.length)) clearInterval(timer);
  }, 500);

  // Best-effort product name for configurator events.
  function productName() {
    var el = document.querySelector('[data-product-title]');
    if (el && el.getAttribute('data-product-title')) return el.getAttribute('data-product-title');
    var h = document.querySelector('.product-title, h1');
    return h ? (h.textContent || '').trim() : '';
  }

  // --- Configurator swatch clicks (pattern / support) -----------------------
  function onSwatchClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest('.variant-color') : null;
    if (!btn) return;
    var value = btn.getAttribute('data-value') || '';
    if (!value) return;
    if (btn.closest('.product-variants-box')) {
      track('select_pattern', { pattern_name: value, item_name: productName() });
    } else if (btn.closest('.product-type')) {
      track('select_support', { support_type: value, item_name: productName() });
    }
  }

  // --- Pattern Lab contest — "Partecipa / scarica regolamento" download ------
  function isRegolamentoAnchor(a) {
    if (!a) return false;
    if (a.getAttribute && a.getAttribute('data-track') === 'partecipa-patternlab') return true;
    var href = a.getAttribute && a.getAttribute('href');
    if (!href) return false;
    return /Murals_Pattern_Lab/i.test(href) && /Regolamento/i.test(href);
  }
  function onRegolamentoClick() {
    track('download_regolamento', {
      event_category: 'contest_pattern_lab',
      event_label: 'partecipa_button',
      page_location: window.location.href
    });
  }
  function bindContestRegolamento(root) {
    var scope = root || document;
    var anchors = scope.querySelectorAll('a[href], a[data-track="partecipa-patternlab"]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      if (a.__muralsRegolamentoBound || !isRegolamentoAnchor(a)) continue;
      a.__muralsRegolamentoBound = true;
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
      a.addEventListener('click', onRegolamentoClick);
    }
  }

  // Kept for cart-drawer.js compatibility (guarded caller). Cart is deprecated
  // in the lead-gen model, so this is intentionally minimal.
  function viewCart() { track('view_cart', {}); }

  function init() {
    document.addEventListener('click', onSwatchClick, true);
    bindContestRegolamento(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MuralsTracking = { track: track, viewCart: viewCart };
})();
